module.exports = __webpack_public_path__ + "img/poster-clip-bg.c760ab61.png";